import React, { useState } from 'react';
import { Icon } from '../icon';
import styles from './input.module.scss';
import { TIcon } from '../icon/icon.model';
import Button from '../button/button';

type InputProps = {
  field?: any;
  className?: string;
  type?: 'text' | 'password' | 'number' | 'textarea';
  placeholder?: string;
  mode?: 'outline' | 'solid';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  color?: 'primary' | 'black' | 'white' | 'light';
  rounded?: 'rounded-sm' | 'rounded-md' | 'rounded-lg' | 'rounded-xl';
  disabled?: boolean;
  togglePassword?: boolean;
  hint?: string;
  tabIndex?: number;
  icon?: {
    name: TIcon;
    visibility: boolean;
    onClick: () => void;
  };
};

const Input = (props: InputProps) => {
  const {
    className,
    mode,
    size,
    color,
    rounded,
    disabled,
    type = 'text',
    field,
    placeholder,
    togglePassword = false,
    hint,
    icon,
    tabIndex,
  } = props;

  const [passwordVisible, setPasswordVisible] = useState<boolean>(false);

  const compressedClasses = `
  ${styles.input}
  ${mode ? styles[mode] : ''}
  ${size ? styles[size] : ''}
  ${color ? styles[color] : ''}
  ${rounded ? styles[rounded] : ''}
   ${className || ''}
`;

  return (
    <div className={styles.inputWrapper}>
      {hint && <div className={styles.inputHint}>{hint}</div>}

      {type === 'textarea' ? (
        <textarea id={field?.name} className={compressedClasses} placeholder={placeholder} {...field} disabled={disabled} />
      ) : (
        <input
          role="input"
          tabIndex={tabIndex}
          id={field?.name}
          className={compressedClasses}
          type={passwordVisible ? 'text' : type}
          placeholder={placeholder}
          {...field}
          disabled={disabled}
        />
      )}
      {togglePassword && (
        <button tabIndex={0} className={styles.absoluteIcon} onClick={() => setPasswordVisible(!passwordVisible)}>
          <Icon content={passwordVisible ? 'viewOff' : 'view'} />
        </button>
      )}

      {icon?.visibility && (
        <Button tabIndex={0} color="transparent" size="xs" className={styles.absoluteIcon} onClick={icon.onClick}>
          <Icon content={icon.name} />
        </Button>
      )}
    </div>
  );
};

export default Input;
